export class Tarjeta {
  id:string
  nombre:string
  codigo:string
}
